export const RELATIONSHIP_INFO = {
  CONFIG_INFO: {
    DEVICE: [
      { key: 'deviceName', label: '장비명', editable: true },
      { key: 'deviceIp', label: 'IP' },
      { key: 'deviceMac', label: 'MAC' },
      { key: 'deviceTypeName', label: '장비종류' },
      // { key: 'deviceProductId', label: 'OS/모델명', editable: true },
      { key: 'deviceCompanyName', label: '제조사' },
      { key: 'deviceDesc', label: '설명(메모)', editable: true },
    ],
    LAN: [
      { key: 'interfaceName', label: '인터페이스명', editable: true },
      { key: 'interfaceMac', label: 'MAC' },
      { key: 'deviceName', label: '연결장비명' },
      { key: 'deviceIp', label: '연결장비IP' },
    ],
  },
  CONNECT_DEVICE: {
    DEVICE: [
      {
        prop: 'netinterfaceObjId',
        columnKey: 'netinterfaceObjId',
        className: 'netinterfaceObjId',
        scopedSlot: 'netinterfaceObjId-slot',
      },
      {
        prop: 'connIfName',
        label: '인터페이스명',
        columnKey: 'connIfName',
        className: 'connIfName',
        scopedSlot: 'connIfName-slot',
        resizable: false,
      },
      {
        prop: 'connDeviceName',
        label: '장비명',
        columnKey: 'connDeviceName',
        className: 'connDeviceName',
        scopedSlot: 'connDeviceName-slot',
        resizable: false,
      },
      {
        prop: 'connDeviceIp',
        label: 'IP주소',
        columnKey: 'connDeviceIp',
        className: 'connDeviceIp',
        scopedSlot: 'connDeviceIp-slot',
        resizable: false,
      },
      {
        prop: 'connDeviceMac',
        label: 'MAC',
        columnKey: 'connDeviceMac',
        className: 'connDeviceMac',
        scopedSlot: 'connDeviceMac-slot',
        resizable: false,
      },
    ],
    LAN: [
      // 회선의 연결정보 표현하지 않음
      // {
      //   prop: 'deviceName',
      //   label: '장비명',
      //   columnKey: 'deviceName',
      //   className: 'deviceName',
      //   scopedSlot: 'deviceName-slot',
      //   resizable: false,
      // },
      // {
      //   prop: 'deviceIp',
      //   label: 'IP주소',
      //   columnKey: 'deviceIp',
      //   className: 'deviceIp',
      //   scopedSlot: 'deviceIp-slot',
      //   resizable: false,
      // },
      // {
      //   prop: 'deviceMac',
      //   label: 'MAC',
      //   columnKey: 'deviceMac',
      //   className: 'deviceMac',
      //   scopedSlot: 'deviceMac-slot',
      //   resizable: false,
      // },
    ],
  },
  CONNECT_DEVICE_DETAIL: [
    [
      { key: 'netinterfaceStatusOper', label: 'Oper상태', formatter: 'label' },
      { key: 'netinterfaceSpeed', label: '대역폭', formatter: 'value' },
      { key: 'vlanId', label: 'VLAN' },
    ],
    [
      { key: 'netinterfaceStatusAdmin', label: 'Admin상태', formatter: 'label' },
      { key: 'netinterfaceDuplex', label: 'Duplex' },
    ],
  ],
  CHANGE_HIST: {
    DEVICE: [
      {
        prop: 'histType',
        label: '변경타입',
        scopedSlot: 'histType-slot',
        width: 80,
        formatter: 'histType',
      },
      {
        prop: 'connectInterfaceName',
        label: '인터페이스명',
        scopedSlot: 'connectInterfaceName-slot',
        formatter: 'connectInterfaceName',
      },
      {
        prop: 'remoteDevice',
        label: '연결장비',
        scopedSlot: 'remoteDevice-slot',
        formatter: 'remoteDevice',
      },
      {
        prop: 'checkDatetime',
        label: '변경시각',
        scopedSlot: 'checkDatetime-slot',
        width: 130,
        formatter: 'checkDatetime',
      },
    ],
    LAN: [
      {
        prop: 'histType',
        label: '변경타입',
        scopedSlot: 'histType-slot',
        width: 80,
        formatter: 'histType',
      },
      {
        prop: 'connectInterfaceName',
        label: '인터페이스명',
        scopedSlot: 'connectInterfaceName-slot',
        formatter: 'connectInterfaceName',
      },
      {
        prop: 'remoteDevice',
        label: '연결장비',
        scopedSlot: 'remoteDevice-slot',
        formatter: 'remoteDevice',
      },
      {
        prop: 'checkDatetime',
        label: '스케줄 수행 시간',
        scopedSlot: 'checkDatetime-slot',
        width: 130,
        formatter: 'checkDatetime',
      },
    ],
  },
};
export const OPERATION_INFO = {
  SERVER: {
    DEFAULT: [
      { key: 'availRateValue', label: '가동률' },
      { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
      { key: 'objDefineName', label: '장비 타입' },
      { key: 'osName', label: 'OS 종류' },
      { key: 'osArchtecture', label: '시스템 종류' },
      { key: 'osServicepackVer', label: '서비스 팩' },
      { key: 'uptime', label: '구동시간' },
      { key: 'adminInfoLabel', label: '관리자 (정/부)' },
    ],
    BASIC: [
      { key: 'availRateValue', label: '가동률' },
      { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
      { key: 'objName', label: '장비명' },
      { key: 'objDefineName', label: '장비 타입' },
      { key: 'ipaddressApplytype', label: 'IP 종류' },
      { key: 'ipaddressIpv4', label: 'IPv4' },
      { key: 'ipaddressIpv6', label: 'IPv6' },
      { key: 'objSubnetmask', label: '서브넷 마스크' },
      { key: 'objMacaddress', label: 'MAC 주소' },
      { key: 'objtypeName', label: 'OS 종류' }, // 성능/운영 요약: osName, 구성: objtypeName을 표현중이라 구성을 따라감.
      { key: 'osServicepackVer', label: '서비스 팩' },
      { key: 'osArchtecture', label: '시스템 종류' },
      { key: 'uptime', label: '구동시간' },
      { key: 'objImportance', label: '중요도' },
      { key: 'adminInfoLabel', label: '관리자 (정/부)' },
    ],
    DETAILS: [
      {
        title: 'HW/SW 정보',
        key: 'hwswInfo',
        contents: [
          { key: 'cpuName', label: 'CPU' },
          { key: 'memTotSize', label: 'MEM 크기', formatter: 'value', unit: 'Byte', unitText: 'B' },
          { key: 'memCnt', label: 'MEM 사용 슬롯 수' },
          { key: 'diskTotSize', label: 'DISK 크기', formatter: 'value', unit: 'Byte', unitText: 'B' },
          { key: 'diskCnt', label: 'DISK 사용 슬롯 수' },
          { key: 'nicDesc', label: 'NIC 정보' },
          { key: 'swCnt', label: 'S/W 사용 수' },
        ],
      },
    ],
  },
  NETDEVICE: {
    DEFAULT: [
      { key: 'availRateValue', label: '가동률' },
      { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
      { key: 'objDefineName', label: '장비 타입' },
      { key: 'objtypeName', label: '장비 종류' },
      { key: 'objCompanyName', label: '제조사' },
      { key: 'objProductId', label: '모델' },
      { key: 'netdeviceUptimeCount', label: '구동시간', formatter: 'day' },
      { key: 'adminInfoLabel', label: '관리자 (정/부)' },
    ],
    BASIC: [
      { key: 'availRateValue', label: '가동률' },
      { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
      { key: 'objName', label: '장비명' },
      { key: 'objDefineName', label: '장비 타입' },
      { key: 'ipaddressApplytype', label: 'IP 종류' },
      { key: 'ipaddressIpv4', label: 'IPv4' },
      { key: 'ipaddressIpv6', label: 'IPv6' },
      { key: 'objSubnetmask', label: '서브넷 마스크' },
      { key: 'objMacaddress', label: 'MAC 주소' },
      { key: 'objtypeName', label: '장비 종류' },
      { key: 'objCompanyName', label: '제조사' },
      { key: 'objProductId', label: '모델' },
      { key: 'netdeviceUptimeCount', label: '구동시간', formatter: 'day' },
      { key: 'netdeviceDesc', label: '설명' },
      { key: 'objImportance', label: '중요도' },
      { key: 'eolDate', label: '판매 종료일 (EOL)', formatter: 'datetime' },
      { key: 'eosDate', label: '서비스 종료일 (EOS)', formatter: 'datetime' },
      { key: 'adminInfoLabel', label: '관리자 (정/부)' },
    ],
    DETAILS: [
      {
        title: 'HW/SW 정보',
        key: 'hwswInfo',
        contents: [
          { key: 'cpuModel', label: 'CPU' },
          { key: 'dram', label: 'DRAM 크기' },
          { key: 'nvram', label: 'NVRAM 크기' },
          { key: 'flashSize', label: '플래시 크기' },
          { key: 'serialNumber', label: '시리얼 넘버' },
          { key: 'motherboardSerialNumber', label: '마더보드 시리얼 넘버' },
          { key: 'motherboardRevisionNumber', label: '마더보드 리비전 넘버' },
          { key: 'powerSupplyPartNumber', label: '파워 서플라이 파트 넘버' },
          { key: 'rebootReason', label: '최근 재부팅 사유' },
          { key: 'configRegister', label: '컨피스 레지스터' },
          { key: 'osVersion', label: 'OS 버전' },
          { key: 'firmwareFile', label: '펌웨어 이미지' },
          { key: 'resourceNumber', label: '실트론 자산번호', enableKey: 'customerId' },
          { key: 'detailedLocation', label: '상세 위치', enableKey: 'customerId' },
        ],
      },
      {
        title: 'TiAMS 연동 정보',
        key: 'Tiams',
        contents: [
          { key: 'assetNoSch', label: '자산번호' },
          { key: 'serialNo', label: 'Serial Number' },
          { key: 'hostNm', label: '장비명' },
          { key: 'mainIpAddr', label: 'IP주소' },
          { key: 'mnftNm', label: '제조사' },
          { key: 'modelNm', label: '모델명' },
          { key: 'instSdt', label: '도입 일자' },
          { key: 'locCoor', label: '상면 좌표' },
          { key: 'bpInfraUserId', label: '운영자 사번' },
          { key: 'bpInfraUserNm', label: '운영자 명' },
          { key: 'usedMonths', label: '사용연한' },
        ],
      },
    ],
  },
  NETINTERFACE: {
    DEFAULT: [
      { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
      { key: 'objDefineName', label: '장비 타입' },
      { key: 'interfaceType', label: '종류' },
      { key: 'netinterfaceIfindex', label: '인덱스' },
      { key: 'netinterfaceName', label: '인터페이스 명' },
      { key: 'netinterfaceStatusAdmin', label: 'Admin 상태', formatter: 'label' },
      { key: 'netinterfaceStatusOper', label: 'Oper 상태', formatter: 'label' },
      { key: 'netinterfaceAlias', label: '별칭' },
      { key: 'ipaddress', label: '인터페이스 IP' },
      { key: 'netinterfaceMacaddress', label: 'MAC 주소' },
      { key: 'adminInfoLabel', label: '관리자 (정/부)' },
    ],
    BASIC: [
      { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
      { key: 'netinterfaceName', label: '인터페이스 명' },
      { key: 'objDefineName', label: '장비 타입' },
      { key: 'ipaddress', label: 'Ipaddress' },
      { key: 'netinterfaceMacaddress', label: 'MAC 주소' },
      { key: 'interfaceType', label: '인터페이스 종류' },
      { key: 'netinterfaceSpeed', label: '대역폭', formatter: 'value' },
      { key: 'netinterfaceSpeedUpdateFlag', label: '대역폭 갱신', formatter: 'label' },
      { key: 'netinterfaceIfindex', label: '인덱스' },
      { key: 'netinterfaceAlias', label: '별칭' },
      { key: 'netinterfaceDuplex', label: 'Duplex' },
      { key: 'netinterfaceStatusOper', label: 'Oper 상태', formatter: 'label' },
      { key: 'netinterfaceStatusAdmin', label: 'Admin 상태', formatter: 'label' },
      { key: 'netinterfaceDevicename', label: '설명' },
      { key: 'adminInfoLabel', label: '관리자 (정/부)' },
    ],
    DETAILS: [
      {
        title: '네트워크 장비 정보',
        key: 'netdeviceInfo',
        contents: [
          { key: 'deviceObjName', label: '장비명' },
          { key: 'deviceObjtypeName', label: '장비 종류' },
          { key: 'deviceIpaddress', label: 'Ipaddress' },
          { key: 'deviceObjCompanyName', label: '제조사' },
          { key: 'deviceObjProductId', label: '모델' },
        ],
      },
    ],
  },
  WIRELESS_DEVICE: {
    AP_CONTROLLER: {
      DEFAULT: [
        { key: 'availRateValue', label: '가동률' },
        { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
        { key: 'objDefineName', label: '장비 타입' },
        { key: 'objtypeName', label: '장비 종류' },
        { key: 'objCompanyName', label: '제조사' },
        { key: 'objProductId', label: '모델' },
        { key: 'netdeviceUptimeCount', label: '구동시간', formatter: 'day' },
        { key: 'adminInfoLabel', label: '관리자 (정/부)' },
      ],
      BASIC: [
        { key: 'availRateValue', label: '가동률' },
        { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
        { key: 'objName', label: '장비명' },
        { key: 'objDefineName', label: '장비 타입' },
        { key: 'ipaddressApplytype', label: 'IP 종류' },
        { key: 'ipaddressIpv4', label: 'IPv4' },
        { key: 'ipaddressIpv6', label: 'IPv6' },
        { key: 'objSubnetmask', label: '서브넷 마스크' },
        { key: 'objMacaddress', label: 'MAC 주소' },
        { key: 'objtypeName', label: '장비 종류' },
        { key: 'objCompanyName', label: '제조사' },
        { key: 'objProductId', label: '모델' },
        { key: 'netdeviceUptimeCount', label: '구동시간' },
        { key: 'netdeviceDesc', label: '설명' },
        { key: 'objImportance', label: '중요도' },
        { key: 'eolDate', label: '판매 종료일 (EOL)', formatter: 'datetime' },
        { key: 'eosDate', label: '서비스 종료일 (EOS)', formatter: 'datetime' },
        { key: 'adminInfoLabel', label: '관리자 (정/부)' },
      ],
      DETAILS: [
        {
          title: 'HW/SW 정보',
          key: 'hwswInfo',
          contents: [
            { key: 'apCount', label: '무선 AP 수' },
            { key: 'cpuModel', label: 'CPU' },
            { key: 'dram', label: 'DRAM 크기' },
            { key: 'nvram', label: 'NVRAM 크기' },
            { key: 'flashSize', label: '플래시 크기' },
            { key: 'serialNumber', label: '시리얼 넘버' },
            { key: 'motherboardSerialNumber', label: '마더보드 시리얼 넘버' },
            { key: 'powerSupplyPartNumber', label: '마더보드 서플라이 파트 넘버' },
            { key: 'rebootReason', label: '최근 재부팅 사유' },
            { key: 'configRegister', label: '컨피스 레지스터' },
            { key: 'osVersion', label: 'OS 버전' },
            { key: 'firmwareFile', label: '펌웨어 이미지' },
          ],
        },
      ],
    },
    WIRELESSAP: {
      DEFAULT: [
        { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
        { key: 'objDefineName', label: '장비 타입' },
        { key: 'objtypeName', label: '장비 종류' },
        { key: 'objCompanyName', label: '제조사' },
        { key: 'objProductId', label: '모델' },
        { key: 'netdeviceUptimeCount', label: '구동시간', formatter: 'day' },
        { key: 'adminInfoLabel', label: '관리자 (정/부)' },
      ],
      BASIC: [
        { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
        { key: 'objName', label: '장비명' },
        { key: 'ssid', label: 'WLAN' },
        { key: 'bssid', label: 'BSSID' },
        { key: 'radioBandChannel', label: '주파수 대역', formatter: 'radioBandChannelLabel' },
        { key: 'apGroup', label: 'AP 그룹' },
        { key: 'controller', label: '컨트롤러' },
        { key: 'bandwidth', label: '대역폭' },
        { key: 'signal', label: '신호세기' },
        { key: 'objDefineName', label: '장비 타입' },
        { key: 'ipaddressApplytype', label: 'IP 종류' },
        { key: 'ipaddressIpv4', label: 'IPv4' },
        { key: 'ipaddressIpv6', label: 'IPv6' },
        { key: 'objSubnetmask', label: '서브넷 마스크' },
        { key: 'objMacaddress', label: 'MAC 주소' },
        { key: 'objtypeName', label: '장비 종류' },
        { key: 'objCompanyName', label: '제조사' },
        { key: 'objProductId', label: '모델' },
        { key: 'netdeviceUptimeCount', label: '구동시간', formatter: 'day' },
        { key: 'netdeviceDesc', label: '설명' },
        { key: 'objImportance', label: '중요도' },
      ],
      DETAILS: [
        {
          title: 'HW/SW 정보',
          key: 'hwswInfo',
          contents: [
            { key: 'cpuModel', label: 'CPU' },
            { key: 'dram', label: 'DRAM 크기' },
            { key: 'nvram', label: 'NVRAM 크기' },
            { key: 'flashSize', label: '플래시 크기' },
            { key: 'serialNumber', label: '시리얼 넘버' },
            { key: 'motherboardSerialNumber', label: '마더보드 시리얼 넘버' },
            { key: 'powerSupplyPartNumber', label: '마더보드 서플라이 파트 넘버' },
            { key: 'rebootReason', label: '최근 재부팅 사유' },
            { key: 'configRegister', label: '컨피스 레지스터' },
            { key: 'osVersion', label: 'OS 버전' },
            { key: 'firmwareFile', label: '펌웨어 이미지' },
          ],
        },
      ],
    },
  },
  DBMS: {
    DEFAULT: [
      { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
      { key: 'objtypeName', label: '장비 타입' },
      { key: 'dbTypeVerLabel', label: 'DB종류(버전)' },
      { key: 'dbmsPort', label: '포트번호' },
      { key: 'dbmsServiceLabel', label: 'SID / 서비스명' },
      { key: 'dbmsUptime', label: '구동시간', formatter: 'datetime' },
      { key: 'adminInfoLabel', label: '관리자 (정/부)' },
    ],
    BASIC: [
      { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
      { key: 'objName', label: '장비명' },
      { key: 'objDefineName', label: '장비 타입' },
      { key: 'dbmsIpaddress', label: 'ipaddress' },
      { key: 'objtypeName', label: 'DB종류' },
      { key: 'objCompanyName', label: '제조사' },
      { key: 'objProductId', label: 'DB 버전' },
      { key: 'dbmsUptime', label: '구동시간', formatter: 'datetime' },
      { key: 'objImportance', label: '중요도' },
      { key: 'adminInfoLabel', label: '관리자 (정/부)' },
    ],
    DETAILS: [
      {
        title: 'Database 설정',
        key: 'dbConfig',
        contents: {
          CUBRID: [
            { key: 'dbmsService', label: ' SID' },
            { key: 'dbmsAlias', label: '서비스 이름' },
            { key: 'dbmsUserid', label: '사용자 ID' },
            { key: 'dbmsUserpw', label: '패스워드', formatter: 'password' },
            { key: 'dbmsPort', label: '브로커 번호' },
            { key: 'dbmsAgentPort', label: 'agent 포트 번호' },
            { key: 'dbmsAgentOs', label: '운영체제' },
            { key: 'dbmsLockMaxCount', label: 'Lock 최대 개수 ' },
            { key: 'dbmsSessionMaxCount', label: '세션 최대 개수' },
          ],
          ORACLE: [
            { key: 'dbmsService', label: ' SID' },
            { key: 'dbmsAlias', label: '서비스 이름' },
            { key: 'dbmsUserid', label: '사용자 ID' },
            { key: 'dbmsUserpw', label: '패스워드', formatter: 'password' },
            { key: 'dbmsPort', label: '포트번호' },
            { key: 'dbmsLockMaxCount', label: 'Lock 최대 개수 ' },
            { key: 'dbmsSessionMaxCount', label: '세션 최대 개수' },
            { key: 'initEnvironmentPath', label: 'Init Environment Path' }, // info버튼 추가해야함
            { key: 'dbmsListener', label: 'Listener Alias' }, // 리스너감지기 버튼 추가
            { key: 'dbmsVipname', label: 'VIP Name' },
            { key: 'dbmsViphost', label: 'VIP Host' },
          ],
          COMMON: [
            { key: 'dbmsService', label: ' SID' },
            { key: 'dbmsAlias', label: '서비스 이름' },
            { key: 'dbmsUserid', label: '사용자 ID' },
            { key: 'dbmsUserpw', label: '패스워드', formatter: 'password' },
            { key: 'dbmsPort', label: '포트번호' },
            { key: 'dbmsLockMaxCount', label: 'Lock 최대 개수 ' },
            { key: 'dbmsSessionMaxCount', label: '세션 최대 개수' },
          ],
        },
      },
    ],
  },
  FMS_SENSOR: {
    DEFAULT: [
      { key: 'availRateValue', label: '가동률' },
      { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
      { key: 'objtypeName', label: '센서 타입' },
      { key: 'rscGetmethodName', label: '수집 방식' },
      { key: 'fmsSensorPort', label: '포트' },
      { key: 'adminInfoLabel', label: '관리자 (정/부)' },
    ],
    // 더보기 미제공
  },
  VMS_OBJECT: {
    // 가상화 서버
    VVM: {
      DEFAULT: [
        { key: 'availRateValue', label: '가동률' },
        { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
        { key: 'objtypeNameWidthTemplate', label: '장비 타입' },
        { key: 'basicinfoSubname', label: '가상화 벤더' },
        { key: 'vmDesc', label: 'VM 별칭' },
        { key: 'VVM_COMMON/OS', label: 'VM 운영체제' },
        { key: 'VVM_COMMON/HOST_IPADDRESS', label: '호스트 IP' },
        { key: 'VVM_COMMON/BOOT_TIME', label: '기동시각', formatter: 'periodVvmBootTime' },
        { key: 'adminInfoLabel', label: '관리자 (정/부)' },
      ],
      BASIC: [
        { key: 'availRateValue', label: '가동률' },
        { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
        { key: 'objName', label: '장비명' },
        { key: 'vmDesc', label: 'VM 별칭' },
        { key: 'ipaddressApplytype', label: 'IP 종류' },
        { key: 'ipaddressIpv4', label: 'IPv4' },
        { key: 'ipaddressIpv6', label: 'IPv6' },
        { key: 'objSubnetmask', label: '서브넷 마스크' },
        { key: 'VVM_COMMON/MACADDRESS', label: 'MAC 주소' },
        { key: 'basicinfoSubname', label: '가상화 벤더' },
        { key: 'objtypeNameWidthTemplate', label: '장비 종류' },
        { key: 'VVM_COMMON/OS', label: 'VM 운영체제' },
        { key: 'VVM_COMMON/HOST_NAME', label: '호스트 정보' },
        { key: 'VVM_COMMON/BOOT_TIME', label: '기동시각', formatter: 'periodVvmBootTime' },
        { key: 'objImportance', label: '중요도' },
        { key: 'adminInfoLabel', label: '관리자 (정/부)' },
      ],
      DETAILS: [
        {
          title: 'HW/SW 정보',
          key: 'hwswInfo',
          contents: {
            VMWARE: [
              { label: 'vCPU', key: 'cpuCoreFormat', formatter: 'vvmCpuCoreFormat' },
              { label: 'CPU 전체용량', key: 'VVM_CPU/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'hz' },
              { label: '메모리 전체용량', key: 'VVM_MEM/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '디스크 수', key: 'VVM_COMMON/DISK_COUNT' },
              { label: '디스크 용량', key: 'VVM_DISK/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '네트워크 어댑터', key: 'VVM_COMMON/NETWORK_ADAPTER' },
              { label: '네트워크 레이블', key: 'VVM_COMMON/NETWORK_LABEL' },
              { label: 'VM 버전', key: 'VVM_COMMON/VM_VERSION' },
              { label: 'VMware Tool 동작', key: 'VVM_COMMON/VMWARE_TOOL_ALIVE' },
              { label: 'Vmware EVC 모드', key: 'VVM_COMMON/EVC_MODE' },
              { label: 'HA 보호여부', key: 'VVM_COMMON/HA_MODE' },
            ],
            KVM: [
              { label: 'vCPU 수', key: 'VVM_COMMON/CPU_CORE_TOTAL_COUNT' },
              { label: '메모리 전체용량', key: 'VVM_MEM/TOTAL_CAPACITY' },
              { label: '디스크 용량', key: 'VVM_DISK/TOTAL_CAPACITY' },
            ],
            HYPERV: [
              { label: 'vCPU', key: 'cpuCoreFormat', formatter: 'vvmCpuCoreFormat' },
              { label: 'CPU 전체용량', key: 'VVM_CPU/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'hz' },
              { label: '메모리 전체용량', key: 'VVM_MEM/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '디스크 수', key: 'VVM_COMMON/DISK_COUNT' },
              { label: '디스크 용량', key: 'VVM_DISK/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '네트워크 레이블', key: 'VVM_COMMON/NETWORK_LABEL' },
              { label: '세대', key: 'VVM_COMMON/GENERATION' },
              { label: '동적메모리 사용 여부', key: 'VVM_COMMON/DYNAMIC_MEMORY_ENABLED' },
              { label: '최대 메모리', key: 'VVM_COMMON/DYNAMIC_MEMORY_MAXIMUM' },
              { label: '최소 메모리', key: 'VVM_COMMON/DYNAMIC_MEMORY_MINIMUM' },
            ],
            XENSERVER: [
              { label: 'vCPU', key: 'cpuCoreFormat', formatter: 'vvmCpuCoreFormat' },
              { label: 'CPU 전체용량', key: 'VVM_CPU/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '메모리 전체용량', key: 'VVM_MEM/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '디스크 수', key: 'VVM_COMMON/DISK_COUNT' },
              { label: '디스크 용량', key: 'VVM_DISK/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '네트워크 레이블', key: 'VVM_COMMON/NETWORK_LABEL' },
              { label: 'VM 버전', key: 'VVM_COMMON/VM_VERSION' },
            ],
            RHEV: [
              { label: 'vCPU', key: 'cpuCoreFormat', formatter: 'vvmCpuCoreFormat' },
              { label: 'CPU 전체용량', key: 'VVM_CPU/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '메모리 전체용량', key: 'VVM_MEM/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '디스크 수', key: 'VVM_COMMON/DISK_COUNT' },
              { label: '디스크 용량', key: 'VVM_DISK/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: 'HA 보호여부', key: 'VVM_COMMON/HA_MODE' },
            ],
          },
        },
      ],
    },
    // 가상화 호스트
    VHO: {
      DEFAULT: [
        { key: 'availRateValue', label: '가동률' },
        { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
        { key: 'objtypeName', label: '장비 종류' },
        { key: 'basicinfoSubname', label: '가상화 벤더' },
        { key: 'VHO_SYSTEM/MANUFACTURING_FIRM', label: '제조업체' },
        { key: 'VHO_SYSTEM/MODEL_NAME', label: '모델' },
        { key: 'vmTemplateCount', label: '가상시스템 / 템플릿' },
        { key: 'VHO_COMMON/BOOT_TIME', label: '기동시각', formatter: 'periodVhoBootTime' },
        { key: 'adminInfoLabel', label: '관리자 (정/부)' },
      ],
      BASIC: [
        { key: 'availRateValue', label: '가동률' },
        { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
        { key: 'objName', label: '장비명' },
        { key: 'objtypeName', label: '장비 종류' },
        { key: 'basicinfoSubname', label: '가상화 벤더' },
        { key: 'ipaddressApplytype', label: 'IP 종류' },
        { key: 'ipaddressIpv4', label: 'IPv4' },
        { key: 'ipaddressIpv6', label: 'IPv6' },
        { key: 'objSubnetmask', label: '서브넷 마스크' },
        { key: 'objMacaddress', label: 'MAC 주소' },
        { key: 'VHO_SYSTEM/MANUFACTURING_FIRM', label: '제조업체' },
        { key: 'VHO_SYSTEM/MODEL_NAME', label: '모델' },
        { key: 'VHO_COMMON/BOOT_TIME', label: '기동시각', formatter: 'periodVhoBootTime' },
        { key: 'objImportance', label: '중요도' },
        { key: 'adminInfoLabel', label: '관리자 (정/부)' },
      ],
      DETAILS: [
        {
          title: 'HW/SW 정보',
          key: 'hwswInfo',
          contents: {
            VMWARE: [
              { label: '가상시스템 수', key: 'VHO_COMMON/VM_COUNT' },
              { label: '템플릿 수', key: 'VHO_COMMON/TEMPLATE_COUNT' },
              { label: 'CPU 코어', key: 'cpuCoreFormat', formatter: 'vhoCpuCoreFormat' },
              { label: '프로세서 유형', key: 'VHO_PROCESSOR/PROCESSOR_TYPE' },
              { label: '프로세서 소켓 수', key: 'VHO_PROCESSOR/PROCESSOR_SOCKET_COUNT' },
              { label: '소켓당 코어 수', key: 'VHO_PROCESSOR/CPU_CORES_PER_SOCKET' },
              { label: '논리 프로세서 수', key: 'VHO_PROCESSOR/CPU_LOGICAL_PROCESSOR_COUNT' },
              { label: '하이퍼스레딩', key: 'VHO_PROCESSOR/HYPER_THREADING_MODE' },
              { label: '메모리 합계', key: 'VHO_MEM/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '시스템 메모리', key: 'VHO_MEM/SYSTEM_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '가상 시스템 메모리', key: 'VHO_MEM/VIRTUAL_SYSTEM_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: 'NIC 수', key: 'VHO_NETWORK/NIC_COUNT' },
              { label: 'vMotion 사용여부', key: 'VHO_COMMON/VMOTION_MODE' },
              { label: 'Vmware EVC 모드', key: 'VHO_COMMON/EVC_MODE' },
              { label: 'vSphere HA 상태', key: 'VHO_COMMON/HA_STATE' },
              { label: 'Fault Tolerance 버전', key: 'VHO_COMMON/FAULT_TOLERANCE_VERSION' },
              { label: '라이센스', key: 'VHO_LICENSE/NAME' },
            ],
            KVM: [
              { label: '가상시스템 수', key: 'VHO_COMMON/VM_COUNT' },
              { label: 'CPU 코어 수', key: 'VHO_COMMON/CPU_CORE_TOTAL_COUNT' },
              { label: '프로세서 유형', key: 'VHO_PROCESSOR/PROCESSOR_TYPE' },
              { label: '프로세서 소켓 수', key: 'VHO_PROCESSOR/PROCESSOR_SOCKET_COUNT' },
              { label: '소켓당 코어 수', key: 'VHO_PROCESSOR/CPU_CORES_PER_SOCKET' },
              { label: '논리 프로세서 수', key: 'VHO_PROCESSOR/CPU_LOGICAL_PROCESSOR_COUNT' },
              { label: '시스템 메모리', key: 'VHO_MEM/SYSTEM_CAPACITY' },
            ],
            HYPERV: [
              { label: '가상시스템 수', key: 'VHO_COMMON/VM_COUNT' },
              { label: 'CPU 코어', key: 'cpuCoreFormat', formatter: 'vhoCpuCoreFormat' },
              { label: '프로세서 유형', key: 'VHO_PROCESSOR/PROCESSOR_TYPE' },
              { label: '프로세서 소켓 수', key: 'VHO_PROCESSOR/PROCESSOR_SOCKET_COUNT' },
              { label: '소켓당 코어 수', key: 'VHO_PROCESSOR/CPU_CORES_PER_SOCKET' },
              { label: '논리 프로세서 수', key: 'VHO_PROCESSOR/CPU_LOGICAL_PROCESSOR_COUNT' },
              { label: '메모리 합계', key: 'VHO_MEM/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: 'NIC 수', key: 'VHO_NETWORK/NIC_COUNT' },
              { label: '운영체제', key: 'VHO_COMMON/OS' },
              { label: '에이전트 버전', key: 'VHO_AGENT/VERSION' },
              { label: '에이전트 상태', key: 'VHO_AGENT/STATE' },
              { label: 'VMRC 상태', key: 'VHO_VMRC/STATE' },
              { label: 'VMRC 포트', key: 'VHO_VMRC/PORT' },
              { label: '안전 VMRC 상태', key: 'VHO_VMRC/SECURE_STATE' },
              { label: 'VMRC 인증 가능 여부', key: 'VHO_VMRC/CERTIFICATION_AVAILABILITY' },
              { label: '가상화 소프트웨어 버전', key: 'VHO_COMMON/SOFTWARE_VERSION' },
            ],
            XENSERVER: [
              { label: '가상시스템 수', key: 'VHO_COMMON/VM_COUNT' },
              { label: '템플릿 수', key: 'VHO_COMMON/TEMPLATE_COUNT' },
              { label: 'CPU 코어', key: 'cpuCoreFormat', formatter: 'vhoCpuCoreFormat' },
              { label: '프로세서 유형', key: 'VHO_PROCESSOR/PROCESSOR_TYPE' },
              { label: '프로세서 소켓 수', key: 'VHO_PROCESSOR/PROCESSOR_SOCKET_COUNT' },
              { label: '소켓당 코어 수', key: 'VHO_PROCESSOR/CPU_CORES_PER_SOCKET' },
              { label: '메모리 합계', key: 'VHO_MEM/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: 'NIC 수', key: 'VHO_NETWORK/NIC_COUNT' },
              { label: '풀 마스터', key: 'VHO_COMMON/POOL_MASTER' },
              { label: 'XenServer 버전', key: 'VHO_COMMON/HYPERVISOR_VERSION' },
            ],
            RHEV: [
              { label: '가상시스템 수', key: 'VHO_COMMON/VM_COUNT' },
              { label: 'CPU 코어', key: 'cpuCoreFormat', formatter: 'vhoCpuCoreFormat' },
              { label: '프로세서 유형', key: 'VHO_PROCESSOR/PROCESSOR_TYPE' },
              { label: '프로세서 소켓 수', key: 'VHO_PROCESSOR/PROCESSOR_SOCKET_COUNT' },
              { label: '메모리 합계', key: 'VHO_MEM/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: 'NIC 수', key: 'VHO_NETWORK/NIC_COUNT' },
              { label: 'kdump 상태', key: 'VHO_COMMON/KDUMP_STATE' },
              { label: 'SELinux 상태', key: 'VHO_COMMON/SELINUX_MODE' },
              { label: '새로운 가상 머신의 스케줄을 위한 최대 여유 메모리', key: 'VHO_COMMON/MAX_SCHEDULING_MEMORY' },
            ],
          },
        },
      ],
    },
    // 호스트 클러스터
    VCL: {
      DEFAULT: [
        { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
        { key: 'objtypeName', label: '장비 종류' },
        { key: 'basicinfoSubname', label: '가상화 벤더' },
        { key: 'VCL_COMMON/HOST_COUNT', label: '호스트 수' },
        { key: 'VCL_COMMON/PROCESSOR_TOTAL_COUNT', label: '총 프로세서 수' },
        { key: 'VCL_COMMON/STORAGE_COUNT', label: '총 스토리지 수' },
        { key: 'adminInfoLabel', label: '관리자 (정/부)' },
      ],
      BASIC: [
      ],
      DETAILS: [
        {
          title: 'HW/SW 정보',
          key: 'hwswInfo',
          contents: {
            VMWARE: [
              { label: 'vSphere DRS', key: 'VCL_COMMON/DRS_MODE' },
              { label: 'vSphere HA', key: 'VCL_COMMON/HA_MODE' },
              { label: 'VMware EVC 모드', key: 'VCL_COMMON/EVC_MODE' },
              { label: 'CPU 전체용량', key: 'VCL_CPU/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'hz' },
              { label: '메모리 전체용량', key: 'VCL_MEM/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '스토리지 전체용량', key: 'VCL_STORAGE/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '호스트 수', key: 'VCL_COMMON/HOST_COUNT' },
              { label: '가상시스템 수', key: 'VCL_COMMON/VM_COUNT' },
              { label: '템플릿 수', key: 'VCL_COMMON/TEMPLATE_COUNT' },
              { label: '총 프로세서 수', key: 'VCL_COMMON/PROCESSOR_TOTAL_COUNT' },
              { label: '스토리지 클러스터 수', key: 'VCL_COMMON/STORAGE_CLUSTER_COUNT' },
              { label: '스토리지 수', key: 'VCL_COMMON/STORAGE_COUNT' },
              { label: 'Vmotion을 사용한 총 마이그레이션 수', key: 'VCL_COMMON/VMOTION_MIGRATION_COUNT' },
            ],
            HYPERV: [
              { label: 'CPU 전체용량', key: 'VCL_CPU/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'hz' },
              { label: '메모리 전체용량', key: 'VCL_MEM/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '스토리지 전체용량', key: 'VCL_STORAGE/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '호스트 수', key: 'VCL_COMMON/HOST_COUNT' },
              { label: '가상시스템 수', key: 'VCL_COMMON/VM_COUNT' },
              { label: '총 프로세서 수', key: 'VCL_COMMON/PROCESSOR_TOTAL_COUNT' },
              { label: '스토리지 수', key: 'VCL_COMMON/STORAGE_COUNT' },
            ],
            XENSERVER: [
              { label: 'DRS 사용유무', key: 'VCL_COMMON/DRS_MODE' },
              { label: 'HA 사용유무', key: 'VCL_COMMON/HA_MODE' },
              { label: 'CPU 전체용량', key: 'VCL_CPU/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'hz' },
              { label: '메모리 전체용량', key: 'VCL_MEM/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '스토리지 전체용량', key: 'VCL_STORAGE/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '호스트 수', key: 'VCL_COMMON/HOST_COUNT' },
              { label: '가상시스템 수', key: 'VCL_COMMON/VM_COUNT' },
              { label: '템플릿 수', key: 'VCL_COMMON/TEMPLATE_COUNT' },
              { label: '총 프로세서 수', key: 'VCL_COMMON/PROCESSOR_TOTAL_COUNT' },
              { label: '스토리지 수', key: 'VCL_COMMON/STORAGE_COUNT' },
              { label: 'XenServer 버전', key: 'VCL_COMMON/HYPERVISOR_VERSION' },
            ],
            RHEV: [
              { label: 'CPU 전체용량', key: 'VCL_CPU/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'hz' },
              { label: '메모리 전체용량', key: 'VCL_MEM/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '호스트 수', key: 'VCL_COMMON/HOST_COUNT' },
              { label: '가상시스템 수', key: 'VCL_COMMON/VM_COUNT' },
              { label: '템플릿 수', key: 'VCL_COMMON/TEMPLATE_COUNT' },
              { label: '총 프로세서 수', key: 'VCL_COMMON/PROCESSOR_TOTAL_COUNT' },
              { label: 'HA 사용유무', key: 'VCL_COMMON/HA_MODE' },
              { label: '클러스터 CPU 유형', key: 'VCL_COMMON/CPU_TYPE' },
              { label: '스레드를 CPU로 사용', key: 'VCL_COMMON/THREAD_AS_CORES' },
              { label: '호환버전', key: 'VCL_COMMON/COMPATIBILITY_VERSION' },
            ],
          },
        },
        {
          title: 'vSphereHA',
          key: 'VMWARE',
          contents: {
            VMWARE: [
              { key: 'VCL_HA/APPROVAL_CONTROL', label: '승인제어' },
              { key: 'VCL_HA/CURRENT_FAILOVER_CAPACITY', label: '현재 페일오버 용량' },
              { key: 'VCL_HA/HOST_MONITORING_MODE', label: '호스트 모니터링' },
              { key: 'VCL_HA/VM_MONITORING_MODE', label: 'VM 모니터링' },
              { key: 'VCL_HA/APPLICATION_MONITORING_MODE', label: '애플리케이션 모니터링' },
            ],
          },
        },
      ],
    },
    // 스토리지
    VDS: {
      DEFAULT: [
        { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
        { key: 'objtypeName', label: '장비 종류' },
        { key: 'basicinfoSubname', label: '가상화 벤더' },
        { key: 'VDS_COMMON/LOCATION', label: '위치' },
        { key: 'VDS_COMMON/TYPE', label: '유형' },
        { key: 'VDS_COMMON/HOST_COUNT', label: '호스트 수' },
        { key: 'vmCountWithTemplate', label: '가상시스템 및 템플릿 수' },
        { key: 'vmCountForHyperV', label: '가상 시스템 수' },
        { key: 'adminInfoLabel', label: '관리자 (정/부)' },
      ],
      BASIC: [
        { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
        { key: 'objName', label: '장비명' },
        { key: 'objtypeName', label: '장비 종류' },
        { key: 'basicinfoSubname', label: '가상화 벤더' },
        { key: 'VDS_COMMON/TYPE', label: '유형' },
        { key: 'objImportance', label: '중요도' },
        { key: 'adminInfoLabel', label: '관리자 (정/부)' },
      ],
      DETAILS: [
        {
          title: 'HW/SW 정보',
          key: 'hwswInfo',
          contents: {
            VMWARE: [
              { label: '위치', key: 'VDS_COMMON/LOCATION' },
              { label: '연결된 호스트 수', key: 'VDS_COMMON/HOST_COUNT' },
              { label: '가상시스템 수', key: 'VDS_COMMON/VM_COUNT' },
              { label: '템플릿 수', key: 'VDS_COMMON/TEMPLATE_COUNT' },
              { label: '전체용량', key: 'VDS_STORAGE/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '파일시스템', key: 'VDS_COMMON/FILE_SYSTEM' },
              { label: '블록크기', key: 'VDS_COMMON/BLOCK_SIZE' },
              { label: '스토리지 I/O 컨트롤', key: 'VDS_COMMON/STORAGE_IO_CONTROL' },

            ],
            KVM: [
            ],
            HYPERV: [
              { label: '연결된 호스트 수', key: 'VDS_COMMON/HOST_COUNT' },
              { label: '가상시스템 수', key: 'VDS_COMMON/VM_COUNT' },
              { label: '전체용량', key: 'VDS_STORAGE/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '파일시스템', key: 'VDS_COMMON/FILE_SYSTEM' },
              { label: '클러스터링 여부', key: 'VDS_COMMON/CLUSTERING' },

            ],
            XENSERVER: [
              { label: '위치', key: 'VDS_COMMON/LOCATION' },
              { label: '연결된 호스트 수', key: 'VDS_COMMON/HOST_COUNT' },
              { label: '가상시스템 수', key: 'VDS_COMMON/VM_COUNT' },
              { label: '템플릿 수', key: 'VDS_COMMON/TEMPLATE_COUNT' },
              { label: '전체용량', key: 'VDS_STORAGE/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '파일시스템', key: 'VDS_COMMON/FILE_SYSTEM' },
              { label: '클러스터링 여부', key: 'VDS_COMMON/CLUSTERING' },

            ],
            RHEV: [
              { label: '위치', key: 'VDS_COMMON/LOCATION' },
              { label: '연결된 호스트 수', key: 'VDS_COMMON/HOST_COUNT' },
              { label: '가상시스템 수', key: 'VDS_COMMON/VM_COUNT' },
              { label: '템플릿 수', key: 'VDS_COMMON/TEMPLATE_COUNT' },
              { label: '전체용량', key: 'VDS_STORAGE/TOTAL_CAPACITY', formatter: 'value', unit: 'MB', unitText: 'B' },
              { label: '파일시스템', key: 'VDS_COMMON/FILE_SYSTEM' },

            ],
          },
        },
      ],
    },
    // 스토리지 클러스터
    VDSC: {
      DEFAULT: [
        { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
        { key: 'objtypeName', label: '장비 타입' },
        { key: 'basicinfoSubname', label: '가상화 벤더' },
        { key: 'VDSC_COMMON/STORAGE_COUNT', label: '스토리지 수' },
        { key: 'VDSC_COMMON/TYPE', label: '유형' },
        { key: 'VDSC_COMMON/VMDK_COUNT', label: 'VMDK 수' },
        { key: 'VDSC_COMMON/SNAPSHOT_COUNT', label: '스냅샷 수' },
        { key: 'adminInfoLabel', label: '관리자 (정/부)' },
      ],
      BASIC: [
        { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
        { key: 'objName', label: '장비명' },
        { key: 'objtypeName', label: '장비 타입' },
        { key: 'basicinfoSubname', label: '가상화 벤더' },
        { key: 'VDSC_COMMON/TYPE', label: '유형' },
        { key: 'objImportance', label: '중요도' },
        { key: 'adminInfoLabel', label: '관리자 (정/부)' },
      ],
      DETAILS: [
        {
          title: 'HW/SW 정보',
          key: 'hwswInfo',
          contents: {
            COMMON: [
              { key: 'VDSC_COMMON/STORAGE_COUNT', label: '스토리지 수' },
              { key: 'VDSC_STORAGE/TOTAL_CAPACITY', label: '전체용량', formatter: 'value', unit: 'MB', unitText: 'B' },
              { key: 'VDSC_COMMON/VMDK_COUNT', label: 'VMDK 수' },
              { key: 'VDSC_COMMON/SNAPSHOT_COUNT', label: '스냅샷 수' },
              { key: 'VDSC_DRS/IO_MATRIC', label: 'I/O 매트릭' },
              { key: 'VDSC_COMMON/DRS_MODE', label: '스토리지 DRS' },
              { key: 'VDSC_DRS/DRS_AUTO_LEVEL', label: '자동화 수준' },
              { key: 'VDSC_DRS/USED_SPACE_THRESHOLD', label: '사용된 공과 임계값', formatter: 'value', unit: '%', unitText: '%' },
              { key: 'VDSC_DRS/IO_WAIT_TIME_THRESHOLD', label: 'I/O 지연 시간 임계값', formatter: 'value', unit: 'ms', unitText: 'ms' },
            ],
          },
        },
      ],
    },
  },
  WAS: {
    DEFAULT: [
      { key: 'objDefineId', label: '장비 타입' },
      { key: 'objtypeName', label: 'WAS 종류' },
      { key: 'objProductId', label: 'WAS 버전' },
      { key: 'javeVerInfo', label: 'JAVA 버전' },
      { key: 'agentManagerName', label: '에이전트 매니저명' },
      { key: 'agentManagerIpaddress', label: '에이전트 매니저 IP' },
      { key: 'version', label: '에이전트 버전' },
      { key: 'wakeup', label: 'WAS 기동시각' },
      { key: 'adminInfoLabel', label: '관리자 (정/부)' },
    ],
    BASIC: [
      { key: 'objDefineId', label: '장비 타입' },
      { key: 'objName', label: '장비명' },
      { key: 'objProductId', label: 'WAS 버전' },
      { key: 'objtypeName', label: 'WAS 종류' },
      { key: 'ipaddressApplytype', label: 'IP 종류' },
      { key: 'ipaddressIpv4', label: 'IPv4' },
      { key: 'ipaddressIpv6', label: 'IPv6' },
      { key: 'javeVerInfo', label: 'JAVA 버전' },
      { key: 'wakeup', label: 'WAS 기동시각' },
      { key: 'adminInfoLabel', label: '관리자 (정/부)' },
    ],
    DETAILS: [
      {
        title: '에이전트 정보',
        key: 'agent',
        contents: [
          { key: 'agentManagerName', label: '에이전트 매니저명' },
          { key: 'agentManagerIpaddress', label: '에이전트 매니저 IP' },
          { key: 'version', label: '에이전트 버전' },
        ],
      },
    ],
  },
  E2E_SERVICE: {
    DEFAULT: [
      { key: 'availRateValue', label: '가동률' },
      { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
      { key: 'objtypeName', label: '장비 타입' },
      { key: 'httpUrl', label: 'URL' },
      { key: 'protocol', label: '프로토콜' },
      { key: 'method', label: '수집방식' },
      { key: 'httpParam', label: '파라미터' },
      { key: 'httpAdjustType', label: '문자열 정합성 여부', formatter: 'httpAdjustTypeSummary' },
      { key: 'agentLabel', label: '에이전트명' },
      { key: 'adminInfoLabel', label: '관리자 (정/부)' },
    ],
    BASIC: [
      { key: 'availRateValue', label: '가동률' },
      { key: 'chngCheckDatetime', label: '최근 변경시각', formatter: 'datetime' },
      { key: 'serviceName', label: 'E2E 서비스명' },
      { key: 'objtypeName', label: '장비 타입' },
      { key: 'protocol', label: '프로토콜' },
      { key: 'adminInfoLabel', label: '관리자 (정/부)' },
    ],
    DETAILS: [
      {
        title: '에이전트 정보',
        key: 'agent',
        contents: [
        ],
      },
      {
        title: '프로토콜 세부 정보',
        key: 'protocol',
        contents: {
          HTTP: [
            { key: 'method', label: '수집방식' },
            { key: 'httpUrl', label: 'URL' },
            { key: 'httpParam', label: '파라미터' },
            { key: 'httpAdjustType', label: '문자열 정합성 여부', formatter: 'httpAdjustTypeDetail' },
            { key: 'httpAdjustText', label: '정합성 문자열' },
            { key: 'dbSettingName', label: 'DB 선택' },
            { key: 'dbSql', label: 'SQL' },
            { key: 'objImportance', label: '중요도' },
          ],
          HTTPS: [
            { key: 'method', label: '수집방식' },
            { key: 'httpUrl', label: 'URL' },
            { key: 'httpParam', label: '파라미터' },
            { key: 'httpAdjustType', label: '문자열 정합성 여부', formatter: 'httpAdjustTypeDetail' },
            { key: 'httpAdjustText', label: '정합성 문자열' },
            { key: 'dbSettingName', label: 'DB 선택' },
            { key: 'dbSql', label: 'SQL' },
            { key: 'httpsCertificateUseFlag', label: 'HTTPS 인증서 사용 유무' },
            { key: 'httpsCertificateName', label: 'HTTPS 인증서 이름' },
            { key: 'objImportance', label: '중요도' },
          ],
          FTP: [
            { key: 'ftpUrl', label: 'URL' },
            { key: 'ftpId', label: '아이디' },
            { key: 'ftpPw', label: '패스워드', formatter: 'password' },
            { key: 'ftpTestType', label: '파일전송 여부' },
            { key: 'ftpFileName', label: '파일이름' },
          ],
          SMTP: [
            { key: 'mailerId', label: '메일아이디' },
            { key: 'mailerPw', label: '메일패스워드', formatter: 'password' },
            { key: 'smtpUrl', label: 'URL' },
            { key: 'smtpCipherType', label: '암호방식' },
            { key: 'smtpSenderApplyFlag', label: '메일전송 유무' },
            { key: 'smtpSenderId', label: '보내는 사람' },
            { key: 'smtpReceiverId', label: '받는 사람' },
            { key: 'smtpCcId', label: '참조' },
            { key: 'smtpContext', label: '메일내용' },
          ],
          POP: [
            { key: 'popUrl', label: 'POP URL' },
            { key: 'popSslUseFlag', label: 'SSL 사용유무' },
          ],
        },
      },
    ],
  },
  SERVICE: {
    DEFAULT: [
      { key: 'changeDatetime', label: '최근 변경시각', formatter: 'datetime' },
      { key: 'objDefineName', label: '장비 종류' },
      { key: 'SERVER', label: '서버', formatter: 'count' },
      { key: 'NETDEVICE', label: '네트워크 장비', formatter: 'count' },
      { key: 'NETINTERFACE', label: '인터페이스', formatter: 'count' },
      { key: 'DBMS', label: '데이터베이스', formatter: 'count' },
      { key: 'E2E', label: 'E2E 서비스', formatter: 'count' },
      { key: 'WAS', label: 'WAS', formatter: 'count' },
    ],
    BASIC: [
      { key: 'objDefineName', label: '장비 종류' },
      { key: 'objName', label: '서비스명' },
      { key: 'SERVER', label: '서버', subContent: true, formatter: 'count' },
      { key: 'NETDEVICE', label: '네트워크 장비', subContent: true, formatter: 'count' },
      { key: 'NETINTERFACE', label: '인터페이스', subContent: true, formatter: 'count' },
      { key: 'DBMS', label: '데이터베이스', subContent: true, formatter: 'count' },
      { key: 'E2E', label: 'E2E 서비스', subContent: true, formatter: 'count' },
      { key: 'WAS', label: 'WAS', subContent: true, formatter: 'count' },
      { key: 'serviceDesc', label: '설명' },
      { key: 'registDatetime', label: '등록일', formatter: 'datetime' },
      { key: 'changeDatetime', label: '변경일', formatter: 'datetime' },
      { key: 'objImportance', label: '중요도' },
    ],
    DETAILS: [
      {
        title: '연결장비',
        key: 'deviceInfo',
        contents: [
          {
            prop: 'elementTypeName',
            label: '구분',
            sortable: true,
            searchable: true,
            width: 120,
          },
          {
            prop: 'elementName',
            label: '노드명',
            sortable: true,
            searchable: true,
          },
          {
            prop: 'ipaddress',
            label: 'IP',
            sortable: true,
            searchable: true,
          },
          // {
          //   prop: 'rscKeyNameList',
          //   label: '구성항목',
          //   sortable: true,
          //   searchable: true,
          // },
        ],
      },
    ],
  },
  SUBMAP: {
    DEFAULT: [
      { key: 'objDefineName', label: '대상 종류', formatter: 'label' },
      { key: 'SERVER', label: '서버', formatter: 'count' },
      { key: 'NETDEVICE', label: '네트워크 장비', formatter: 'count' },
      { key: 'NETINTERFACE', label: '인터페이스', formatter: 'count' },
      { key: 'FMS_SENSOR', label: '시설 장비', formatter: 'count' },
      { key: 'DBMS', label: '데이터베이스', formatter: 'count' },
      { key: 'E2E_SERVICE', label: 'E2E 서비스', formatter: 'count' },
      { key: 'VMS_OBJECT', label: '가상화 서버', formatter: 'count' },
      { key: 'WAS', label: 'WAS', formatter: 'count' },
      { key: 'SERVICE', label: '서비스', formatter: 'count' },
    ],
  },
  CUSTOM: {
    DEFAULT: [
      { key: 'objDefineName', label: '대상 종류', formatter: 'label' },
      { key: 'SERVER', label: '서버', formatter: 'count' },
      { key: 'NETDEVICE', label: '네트워크 장비', formatter: 'count' },
      { key: 'NETINTERFACE', label: '인터페이스', formatter: 'count' },
      { key: 'FMS_SENSOR', label: '시설 장비', formatter: 'count' },
      { key: 'DBMS', label: '데이터베이스', formatter: 'count' },
      { key: 'E2E_SERVICE', label: 'E2E 서비스', formatter: 'count' },
      { key: 'VMS_OBJECT', label: '가상화 서버', formatter: 'count' },
      { key: 'WAS', label: 'WAS', formatter: 'count' },
      { key: 'SERVICE', label: '서비스', formatter: 'count' },
    ],
  },
};
// 운영상태 && 가동률 조회 자원
export const OPER_STATE_RSC_LIST = {
  SERVER: [{ managetypeId: 'SMS', managetypeKey: '_', rsctypeId: 'RUNNINGSTATUS', rscId: 'SERVER_ALIVE', rscKey: '_' }],
  NETDEVICE: [{ managetypeId: 'NMS', managetypeKey: 'ND', rsctypeId: 'ND_RUNNINGSTATUS', rscId: 'NETDEVICE_ALIVE', rscKey: '_' }],
  FMS_SENSOR: {
    FUPS: [{ managetypeId: 'FMS', objtypeId: 'FUPS', rscId: 'UPS_ALIVE', rscKey: '_', rsctypeId: 'FUPS_RUNNINGSTATUS' }],
    // 항온항습기
    FTHEHYGRO: [{ managetypeId: 'FMS', objtypeId: 'FTHEHYGRO', rscId: 'THEHYGRO_ALIVE', rscKey: '_', rsctypeId: 'FTHEHYGRO_RUNNINGSTATUS' }],
    // 온습도 센서
    FTH: [{ managetypeId: 'FMS', objtypeId: 'FTH', rscId: 'TH_ALIVE', rscKey: '_', rsctypeId: 'FTH_RUNNINGSTATUS' }],
    // 누수 센서
    FWLDS: [{ managetypeId: 'FMS', objtypeId: 'FWLDS', rscId: 'WLDS_ALIVE', rscKey: '_', rsctypeId: 'FWLDS_RUNNINGSTATUS' }],
    // 소방 설비
    FFIREDS: [{ managetypeId: 'FMS', objtypeId: 'FFIREDS', rscId: 'FIREDS_ALIVE', rscKey: '_', rsctypeId: 'FFIREDS_RUNNINGSTATUS' }],
    // 분전반
    FVSBMS: [{ managetypeId: 'FMS', objtypeId: 'FVSBMS', rscId: 'VSBMS_ALIVE', rscKey: '_', rsctypeId: 'FVSBMS_RUNNINGSTATUS' }],
    // 도어 센서
    FSENSOR: [{ managetypeId: 'FMS', objtypeId: 'FSENSOR', rscId: 'SENSOR_ALIVE', rscKey: '_', rsctypeId: 'FSENSOR_RUNNINGSTATUS' }],
    // 발전기
    FGCU: [{ managetypeId: 'FMS', objtypeId: 'FGCU', rscId: 'GCU_ALIVE', rscKey: '_', rsctypeId: 'FGCU_RUNNINGSTATUS' }],
    // 선형온도 센서
    // rscId 규정 다름
    // 운영상태 : 각 (RSCTYPE_ID)_RUNNINGSTATUS 사용 확인
    FTEMP: [{ managetypeId: 'FMS', objtypeId: 'FTEMP', rscId: 'FTEMP_ALIVE', rscKey: '_', rsctypeId: 'FTEMP_RUNNINGSTATUS' }],
    // 정류기
    // FRT (정류기)의 경우 RUNNINGSTATUS 없음
    FRT: [{ managetypeId: 'FMS', objtypeId: 'FRT', rscId: 'FRT_ALIVE', rscKey: '_', rsctypeId: 'FRT_RUNNINGSTATUS' }],
  },
  VMS_OBJECT: {
    VHO: [{ managetypeId: 'VMS', managetypeKey: 'VHO', rsctypeId: 'VHO_RUNNINGSTATUS', rscId: 'ALIVE', rscKey: '_' }],
    VVM: [{ managetypeId: 'VMS', managetypeKey: 'VVM', rsctypeId: 'VVM_RUNNINGSTATUS', rscId: 'ALIVE', rscKey: '_' }],
  },
  WIRELESS_DEVICE: {
    AP_CONTROLLER: [{ managetypeId: 'NMS', managetypeKey: 'ND', rsctypeId: 'ND_RUNNINGSTATUS', rscId: 'NETDEVICE_ALIVE', rscKey: '_' }],
    WIRELESSAP: [{ managetypeId: 'NMS', managetypeKey: 'ND', rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_STATUS', rscKey: '_' }],
  },
  E2E_SERVICE: [{ managetypeId: 'E2E', rsctypeId: 'SERVICESTATUS', rscId: 'SERVICE_STATUS' }],
};

// 관리대상의 성능정보 조회 자원
export const PERF_RSC_LIST = {
  SERVER: {
    RSC: [
      [
        // cpu
        { rsctypeId: 'CPU', rscId: 'TOTAL_USERATE', rscKey: '_' },
      ],
      [
        // mem
        { rsctypeId: 'MEM_PHY', rscId: 'USERATE', rscKey: '_' },
      ],
      [
        // disk
        { rsctypeId: 'DISK', rscId: 'DISK_USERATE', rscKey: '_' },
      ],
    ],
    NAME: ['CPU 사용률(%)', '메모리 사용률(%)', '디스크 사용률(%)'],
  },
  NETDEVICE: {
    RSC: [
      [
        // cpu
        { rsctypeId: 'DEVICE_PERF', rscId: 'CPU_USERATE', rscKey: '_' },
      ],
      [
        // mem
        { rsctypeId: 'DEVICE_PERF', rscId: 'MEM_USERATE', rscKey: '_' },
      ],
      [
        // temp
        { rsctypeId: 'DEVICE_PERF', rscId: 'DEVICE_TEMP', rscKey: '_' },
      ],
    ],
    NAME: ['CPU 사용률(%)', '메모리 사용률(%)', '장비 온도'],
  },
  NETINTERFACE: {
    RSC: [
      [
        { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_BPS_IN', rscKey: '_' },
        { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_BPS_OUT', rscKey: '_' },
      ],
      [
        { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPS_IN', rscKey: '_' },
        { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_PPS_OUT', rscKey: '_' },
      ],
      [
        { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_USERATE_IN', rscKey: '_' },
        { rsctypeId: 'TRAFFIC', rscId: 'TRAFFIC_USERATE_OUT', rscKey: '_' },
      ],
    ],
    NAME: ['bps I/O(bps)', 'pps I/O(pps)', '이용률 I/O(%)'],
  },
  WIRELESS_DEVICE: {
    AP_CONTROLLER: {
      RSC: [
        [
          { rsctypeId: 'WIRELESS_CONTROLLER', rscId: 'CLIENT_COUNT', rscKey: '_' },
        ],
        [
          { rsctypeId: 'DEVICE_TRAFFIC', rscId: 'TRAFFIC_BPS_IN', rscKey: '_' },
        ],
        [
          { rsctypeId: 'DEVICE_TRAFFIC', rscId: 'TRAFFIC_BPS_OUT', rscKey: '_' },
        ],
      ],
      NAME: ['접속자 수', '트래픽 IN (bps)', '트래픽 OUT (bps)'],
    },
    WIRELESSAP: {
      RSC: [
        [
          { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'CLIENT_COUNT', rscKey: '_' },
        ],
        [
          { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_TRAFFIC_BPS_IN', rscKey: '_' },
        ],
        [
          { rsctypeId: 'WIRELESS_ACCESSPOINT', rscId: 'AP_TRAFFIC_BPS_OUT', rscKey: '_' },
        ],
      ],
      NAME: ['접속자 수', '트래픽 IN (bps)', '트래픽 OUT (bps)'],
    },
  },
  DBMS: {
    RSC: [
      [
        // 세션
        { rsctypeId: 'SESS', rscId: 'DB_SESS_COUNT', rscKey: '_' },
      ],
      [
        // lock
        { rsctypeId: 'LOCK', rscId: 'DB_LOCK_COUNT', rscKey: '_' },
      ],
      [
        // 공간사용률
        { rsctypeId: 'TABLESPACE', rscId: 'DB_TABLESPACE_USERATE', rscKey: '_' },
      ],
    ],
    NAME: ['세션 수(count)', 'Lock(count)', '공간사용률(%)'],
  },
  FMS_SENSOR: {
    // UPS
    FUPS: {
      RSC: [
        [
          // 전압 IO
          { rsctypeId: 'FUPS', rscId: 'INPUT_VOLTAGE', rscKey: '_' },
          { rsctypeId: 'FUPS', rscId: 'OUTPUT_VOLTAGE', rscKey: '_' },
        ],
        [
          // 전류 IO
          { rsctypeId: 'FUPS', rscId: 'INPUT_CURRENT', rscKey: '_' },
          { rsctypeId: 'FUPS', rscId: 'OUTPUT_CURRENT', rscKey: '_' },
        ],
        [
          // 용량
          { rsctypeId: 'FUPS', rscId: 'CAPACITY', rscKey: '_' },
        ],
      ],
      NAME: ['전압 I/O(V)', '전류 I/O(A)', '용량(%)'],
    },
    // 항온항습기
    FTHEHYGRO: {
      RSC: [
        [
          // 온도
          { rsctypeId: 'FTHEHYGRO', rscId: 'CUR_TEMPERATURE', rscKey: '_' },
        ],
        [
          // 습도
          { rsctypeId: 'FTHEHYGRO', rscId: 'CUR_HUMIDITY', rscKey: '_' },
        ],
      ],
      NAME: ['온도(℃)', '습도'],
    },
    // 온습도 센서
    FTH: {
      RSC: [
        [
          // 온도
          { rsctypeId: 'FTH', rscId: 'TEMPERATURE', rscKey: '_' },
        ],
        [
          // 습도
          { rsctypeId: 'FTH', rscId: 'HUMIDITY', rscKey: '_' },
        ],
      ],
      NAME: ['온도(℃)', '습도'],
    },
    // 선형온도 센서
    FTEMP: [
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE1', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE2', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE3', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE4', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE5', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE6', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE7', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE8', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE9', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE10', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE11', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE12', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE13', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE14', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE15', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE16', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE17', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE18', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE19', rscKey: '_' },
      // { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE20', rscKey: '_' },
    ],
    // 누수 센서
    FWLDS: {
      RSC: [
        [
          // 누수경보
          { rsctypeId: 'FWLDS', rscId: 'WARN_LOSSOFFLOW', rscKey: '_' },
        ],
      ],
      NAME: ['누수 경보'],
    },
    // 소방 설비
    FFIREDS: {
      RSC: [
        [
          // 연기
          { rsctypeId: 'FFIREDS', rscId: 'FDA', rscKey: '_' },
        ],
        [
          // 열
          { rsctypeId: 'FFIREDS', rscId: 'FDB', rscKey: '_' },
        ],
        [
          // 하론
          { rsctypeId: 'FFIREDS', rscId: 'FDH', rscKey: '_' },
        ],
      ],
      NAME: ['연기감지 상태', '열감지 상태', '하론방출 상태'],
    },
    // 분전반
    FVSBMS: {
      RSC: [
        [
          // 선간전압(R/S/T)
          { rsctypeId: 'FVSBMS', rscId: 'LINE_VOLTAGE_R', rscKey: '_' },
          { rsctypeId: 'FVSBMS', rscId: 'LINE_VOLTAGE_S', rscKey: '_' },
          { rsctypeId: 'FVSBMS', rscId: 'LINE_VOLTAGE_T', rscKey: '_' },
        ],
        [
          // 전류(R/S/T)
          { rsctypeId: 'FVSBMS', rscId: 'CURRENT_R', rscKey: '_' },
          { rsctypeId: 'FVSBMS', rscId: 'CURRENT_S', rscKey: '_' },
          { rsctypeId: 'FVSBMS', rscId: 'CURRENT_T', rscKey: '_' },
        ],
        [
          // 상전압(R/S/T)
          { rsctypeId: 'FVSBMS', rscId: 'PHASE_VOLTAGE_R', rscKey: '_' },
          { rsctypeId: 'FVSBMS', rscId: 'PHASE_VOLTAGE_S', rscKey: '_' },
          { rsctypeId: 'FVSBMS', rscId: 'PHASE_VOLTAGE_T', rscKey: '_' },
        ],
      ],
      NAME: ['선간전압(R/S/T)(V)', '전류(R/S/T)(A)', '상전압(R/S/T)(V)'],
    },
    // 동작센서(도어 센서)
    FSENSOR: {
      RSC: [
        [
          // 문열림 상태
          { rsctypeId: 'FSENSOR', rscId: 'FMS_DOOR_STATUS', rscKey: '_' },
        ],
      ],
      NAME: ['문열림 상태'],
    },
    // 에어플로우
    FAIRFLOW: {
      RSC: [
        [
          // 공기흐름 속도
          { rsctypeId: 'FAIRFLOW', rscId: '', rscKey: '_' },
        ],
      ],
      NAME: ['공기흐름 속도 (m/min)'],
    },
    // 카메라
    // FCAM: [
    //   // 미정
    //   { rsctypeId: 'FCAM', rscId: '', rscKey: '_' },
    // ],
    // 전력분배
    FPDUS: {
      RSC: [
        [
          // 전류
          { rsctypeId: 'FPDUS', rscId: 'CURRENT', rscKey: '_' },
        ],
        [
          // 전압
          { rsctypeId: 'FPDUS', rscId: 'VOLTAGE', rscKey: '_' },
        ],
        [
          // 전력
          { rsctypeId: 'FPDUS', rscId: 'POWER', rscKey: '_' },
        ],
      ],
      NAME: ['전류(A)', '전압(V)', '전력(W)'],
    },
    // 소음
    FNSDS: {
      RSC: [
        [
          // 소음크기
          { rsctypeId: 'FNSDS', rscId: 'NOISE', rscKey: '_' },
        ],
      ],
      NAME: ['소음크기(db)'],
    },
    // 디지털 변환기
    FADC: [
      // { rsctypeId: 'FADC', rscId: 'CH1', rscKey: '_' },
      // { rsctypeId: 'FADC', rscId: 'CH2', rscKey: '_' },
      // { rsctypeId: 'FADC', rscId: 'CH3', rscKey: '_' },
      // { rsctypeId: 'FADC', rscId: 'CH4', rscKey: '_' },
      // { rsctypeId: 'FADC', rscId: 'CH5', rscKey: '_' },
      // { rsctypeId: 'FADC', rscId: 'CH6', rscKey: '_' },
    ],
    // 전압/전류 감시
    FVA: [
      // { rsctypeId: 'FVA', rscId: 'CH1_POWER', rscKey: '_' },
    ],
    // 단상전압감시
    FCM: [
      // { rsctypeId: 'FCM', rscId: 'CH1', rscKey: '_' },
    ],
    // 발전기
    FGCU: {
      RSC: [
        [
          // 배터리전압
          { rsctypeId: 'FGCU', rscId: 'BATTERY_VOLTAGE', rscKey: '_' },
        ],
        [
          // 상전압(R/T/S)
          { rsctypeId: 'FGCU', rscId: 'PHASE_VOLTAGE_R', rscKey: '_' },
          { rsctypeId: 'FGCU', rscId: 'PHASE_VOLTAGE_S', rscKey: '_' },
          { rsctypeId: 'FGCU', rscId: 'PHASE_VOLTAGE_T', rscKey: '_' },
        ],
        [
          // 상전류(R/T/S)
          { rsctypeId: 'FGCU', rscId: 'PHASE_CURRENT_R', rscKey: '_' },
          { rsctypeId: 'FGCU', rscId: 'PHASE_CURRENT_S', rscKey: '_' },
          { rsctypeId: 'FGCU', rscId: 'PHASE_CURRENT_T', rscKey: '_' },
        ],
      ],
      NAME: ['배터리전압(V)', '상전압(R/T/S)(V)', '상전류(R/T/S)(A)'],
    },
    // 정류기
    FRT: {
      RSC: [
        [
          // 입력전압(AB,BC,CA)
          { rsctypeId: 'FRT', rscId: 'INPUT_VOLTAGE_AB', rscKey: '_' },
          { rsctypeId: 'FRT', rscId: 'INPUT_VOLTAGE_BC', rscKey: '_' },
          { rsctypeId: 'FRT', rscId: 'INPUT_VOLTAGE_CA', rscKey: '_' },
        ],
        [
          // 입력전류(A,B,C)
          { rsctypeId: 'FRT', rscId: 'INPUT_CURRENT_A', rscKey: '_' },
          { rsctypeId: 'FRT', rscId: 'INPUT_CURRENT_B', rscKey: '_' },
          { rsctypeId: 'FRT', rscId: 'INPUT_CURRENT_C', rscKey: '_' },
        ],
        [
          // 부하율
          { rsctypeId: 'FRT', rscId: 'LOAD_FACTOR', rscKey: '_' },
        ],
      ],
      NAME: ['입력전압(AB,BC,CA)(V)', '입력전류(A,B,C)(A)', '부하율(%)'],
    },
  },
  VMS_OBJECT: {
    // 호스트
    VHO: {
      RSC: [
        [
          { rsctypeId: 'VHO_CPU', rscId: 'USERATE', rscKey: '_' },
        ],
        [
          { rsctypeId: 'VHO_MEM', rscId: 'USERATE', rscKey: '_' },
        ],
        [
          { rsctypeId: 'VHO_DISK', rscId: 'BPS_READ', rscKey: '_' },
          { rsctypeId: 'VHO_DISK', rscId: 'BPS_WRITE', rscKey: '_' },
        ],
      ],
      NAME: ['CPU 사용률(%)', '메모리 사용률(%)', 'DISK I/O(bps)'],
    },
    // VM
    VVM: {
      RSC: [
        [
          { rsctypeId: 'VVM_CPU', rscId: 'USERATE', rscKey: '_' },
        ],
        [
          { rsctypeId: 'VVM_MEM', rscId: 'USERATE', rscKey: '_' },
        ],
        [
          { rsctypeId: 'VVM_DISK', rscId: 'USERATE', rscKey: '_' },
        ],
      ],
      NAME: ['CPU 사용률(%)', '메모리 사용률(%)', '스토리지 사용률(%)'],
    },
    // 호스트 클러스터
    VCL: {
      RSC: [
        [
          { rsctypeId: 'VCL_CPU', rscId: 'USERATE', rscKey: '_' },
        ],
        [
          { rsctypeId: 'VCL_MEM', rscId: 'USERATE', rscKey: '_' },
        ],
        [
          { rsctypeId: 'VCL_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
          { rsctypeId: 'VCL_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
        ],
      ],
      NAME: ['CPU 사용률(%)', '메모리 사용률(%)', '네트워크 I/O(bps)'],
    },
    // 스토리지
    VDS: {
      RSC: [
        [
          { rsctypeId: 'VDS_STORAGE', rscId: 'USERATE', rscKey: '_' },
        ],
      ],
      NAME: ['스토리지 사용률(%)'],
    },
    // 스토리지 클러스터
    VDSC: {
      RSC: [
        [
          { rsctypeId: 'VDSC_STORAGE', rscId: 'USERATE', rscKey: '_' },
        ],
      ],
      NAME: ['스토리지 사용률(%)'],
    },
  },
  WAS: {
    RSC: [
      [
        { rsctypeId: 'SERVICE', rscId: 'TPS', rscKey: '_' },
      ],
      [
        { rsctypeId: 'SERVICE', rscId: 'ELAPSED_TIME', rscKey: '_' },
      ],
      [
        { rsctypeId: 'JVM', rscId: 'HEAP_USAGE', rscKey: '_' },
      ],
    ],
    NAME: ['TPS(count/s)', '응답시간(ms)', 'JVM사용률(%)'],
  },
  E2E_SERVICE: {
    RSC: [
      [
        { rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_TOTAL' },
      ],
      [
        { rsctypeId: 'SERVICESTATUS', rscId: 'AVAIL' },
      ],
      [
        { rsctypeId: 'SERVICESTATUS', rscId: 'SERVICE_STATUS_CODE' },
      ],
    ],
    NAME: ['총 응답시간(ms)', '가동률(%)', '상태코드 발생 수(count)'],
  },
};

export const OPERATION_RSC_LIST = {
  FMS_SENSOR: {
    FUPS: [
      { rsctypeId: 'FUPS', rscId: 'INPUT_VOLTAGE', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'OUTPUT_VOLTAGE', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'CAPACITY', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'LOADING', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'INPUT_FREQUENCY', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'OUTPUT_FREQUENCY', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'INPUT_CURRENT', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'OUTPUT_CURRENT', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'BATTERY_STATUS', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'BATTERY_VOLTAGE', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'BATTERY_CURRENT', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'TEMPERATURE', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'INTERRUPT_INPUT_POWER', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'OPER_BYPASS', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'FREQUENCY', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'MODEL_NAME', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'SOFTWARE_VERSION', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'AGENT_SOFTWARE_VERSION', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'PHASE_VOLTAGE_R', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'PHASE_VOLTAGE_S', rscKey: '_' },
      { rsctypeId: 'FUPS', rscId: 'PHASE_VOLTAGE_T', rscKey: '_' },
    ],
    FTHEHYGRO: [
      { rsctypeId: 'FTHEHYGRO', rscId: 'CUR_TEMPERATURE', rscKey: '_' },
      { rsctypeId: 'FTHEHYGRO', rscId: 'SET_TEMPERATURE', rscKey: '_' },
      { rsctypeId: 'FTHEHYGRO', rscId: 'CUR_HUMIDITY', rscKey: '_' },
      { rsctypeId: 'FTHEHYGRO', rscId: 'SET_HUMMIDITY', rscKey: '_' },
      { rsctypeId: 'FTHEHYGRO', rscId: 'SET_RUNNING_STATUS', rscKey: '_' },
      { rsctypeId: 'FTHEHYGRO', rscId: 'RUNNING_STATUS_COLDROOM', rscKey: '_' },
      { rsctypeId: 'FTHEHYGRO', rscId: 'RUNNING_STATUS_WARMROOM', rscKey: '_' },
      { rsctypeId: 'FTHEHYGRO', rscId: 'RUNNING_INCREASE_HUMMIDITY', rscKey: '_' },
      { rsctypeId: 'FTHEHYGRO', rscId: 'RUNNING_DECREASE_HUMMIDITY', rscKey: '_' },
      { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_HOT_TEMPERATURE', rscKey: '_' },
      { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_HIGH_HUMMIDITY', rscKey: '_' },
      { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_TEMPERATURE', rscKey: '_' },
      { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_LEAK', rscKey: '_' },
      { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_HUMIDITY', rscKey: '_' },
      { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_COMP1', rscKey: '_' },
      { rsctypeId: 'FTHEHYGRO', rscId: 'WARN_COMP2', rscKey: '_' },
    ],
    FTH: [
      { rsctypeId: 'FTH', rscId: 'TEMPERATURE', rscKey: '_' },
      { rsctypeId: 'FTH', rscId: 'HUMIDITY', rscKey: '_' },
    ],
    FTEMP: [
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE1', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE2', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE3', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE4', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE5', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE6', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE7', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE8', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE9', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE10', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE11', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE12', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE13', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE14', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE15', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE16', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE17', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE18', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE19', rscKey: '_' },
      { rsctypeId: 'FTEMP', rscId: 'TEMPERATURE20', rscKey: '_' },
    ],
    FWLDS: [
      { rsctypeId: 'FWLDS', rscId: 'WARN_LOSSOFFLOW', rscKey: '_' },
    ],
    FFIREDS: [
      { rsctypeId: 'FFIREDS', rscId: 'FDA', rscKey: '_' },
      { rsctypeId: 'FFIREDS', rscId: 'FDB', rscKey: '_' },
      { rsctypeId: 'FFIREDS', rscId: 'FDH', rscKey: '_' },
    ],
    FSENSOR: [
      { rsctypeId: 'FSENSOR', rscId: 'FMS_DOOR_STATUS', rscKey: '_' },
    ],
    FVSBMS: [
      { rsctypeId: 'FVSBMS', rscId: 'PHASE_VOLTAGE_R', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'PHASE_VOLTAGE_S', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'PHASE_VOLTAGE_T', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'LINE_VOLTAGE_R', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'LINE_VOLTAGE_S', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'LINE_VOLTAGE_T', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CURRENT_R', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CURRENT_S', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CURRENT_T', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH1_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH2_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH3_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH4_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH5_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH6_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH7_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH8_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH9_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH10_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH11_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH12_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH13_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH14_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH15_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH16_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH17_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH18_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH19_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH20_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH21_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'REACTIVE_PWR', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'POWER_FACTOR', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'REACTIVE_PWR_Q', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'INTEGRATE_PWR_Q', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'FREQUENCY', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'HORIZONTAL_RADIATION', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'TILT_RADIATION', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'OUTSIDE_TEMPERATURE', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'MODULE_TEMPERATURE', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH22_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH23_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH24_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH25_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH26_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH27_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH28_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH29_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH30_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH31_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH32_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH33_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH34_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH35_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH36_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH37_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH38_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH39_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH40_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH41_POWER', rscKey: '_' },
      { rsctypeId: 'FVSBMS', rscId: 'CH42_POWER', rscKey: '_' },
    ],
    FGCU: [
      { rsctypeId: 'FGCU', rscId: 'PHASE_VOLTAGE_R', rscKey: '_' },
      { rsctypeId: 'FGCU', rscId: 'PHASE_VOLTAGE_S', rscKey: '_' },
      { rsctypeId: 'FGCU', rscId: 'PHASE_VOLTAGE_T', rscKey: '_' },
      { rsctypeId: 'FGCU', rscId: 'LINE_VOLTAGE_R', rscKey: '_' },
      { rsctypeId: 'FGCU', rscId: 'LINE_VOLTAGE_S', rscKey: '_' },
      { rsctypeId: 'FGCU', rscId: 'LINE_VOLTAGE_T', rscKey: '_' },
      { rsctypeId: 'FGCU', rscId: 'PHASE_CURRENT_R', rscKey: '_' },
      { rsctypeId: 'FGCU', rscId: 'PHASE_CURRENT_S', rscKey: '_' },
      { rsctypeId: 'FGCU', rscId: 'PHASE_CURRENT_T', rscKey: '_' },
      { rsctypeId: 'FGCU', rscId: 'BATTERY_VOLTAGE', rscKey: '_' },
      { rsctypeId: 'FGCU', rscId: 'OIL_PRESS', rscKey: '_' },
      { rsctypeId: 'FGCU', rscId: 'WATER_TEMP', rscKey: '_' },
      { rsctypeId: 'FGCU', rscId: 'POWER_FACTOR', rscKey: '_' },
      { rsctypeId: 'FGCU', rscId: 'APPARENT_PWR', rscKey: '_' },
      { rsctypeId: 'FGCU', rscId: 'ACTIVE_PWR', rscKey: '_' },
      { rsctypeId: 'FGCU', rscId: 'REACTIVE_PWR', rscKey: '_' },
      { rsctypeId: 'FGCU', rscId: 'GEN_FREQUENCY', rscKey: '_' },
    ],
    FRT: [
      { rsctypeId: 'FRT', rscId: 'DC_VOLTAGE', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'DC_CURRENT', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_VOLTAGE', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CURRENT', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CHARGING', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE1', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE2', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE3', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE4', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE5', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE6', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE7', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE8', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE9', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE10', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE11', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE12', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE13', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE14', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE15', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE16', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE17', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE18', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE19', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE20', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE21', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE22', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE23', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE24', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'LOAD_VOLTAGE', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'LOAD_CURRENT', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'LOAD_FACTOR', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'POWER_FACTOR_A', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'POWER_FACTOR_B', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'POWER_FACTOR_C', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE25', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE26', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE27', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE28', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE29', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE30', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE31', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE32', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE33', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE34', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE35', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE36', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE37', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE38', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE39', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE40', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE41', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE42', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE43', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE44', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE45', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE46', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE47', rscKey: '_' },
      { rsctypeId: 'FRT', rscId: 'BATTERY_CELL_VOLTAGE48', rscKey: '_' },
    ],
  },
};

export const CONFIG_RSC_LIST = {
};


export const LINE_CHART_OPTION = {
  title: false,
  credits: false,
  rangeSelector: false,
  scrollbar: false,
  legend: false,
  lang: {
    noData: '데이터 없음',
  },
  boost: {
    enabled: true,
    useGPUTranslations: true,
  },
  navigator: {
    enabled: false,
  },
  chart: {
    type: 'line',
    backgroundColor: 'transparent',
    spacingTop: 5,
    spacingBottom: 5,
  },
  xAxis: {
    visible: false,
    crosshair: true,
  },
  yAxis: {
    visible: false,
  },
  plotOptions: {
    series: {
    },
  },
  series: [],
  colors: [],
  tooltip: {
    split: false,
    shared: true,
    valueDecimals: 2,
    useHTML: true,
  },
};

export const PIE_CHART_OPTION = {
  chart: {
    type: 'pie',
    backgroundColor: 'transparent',
    spacing: [0, 0, 0, 0],
  },
  time: {
    useUTC: false,
  },
  lang: {
    noData: '데이터 없음',
  },
  title: false,
  credits: false,
  tooltip: {
    useHTML: true,
    outside: true,
  },
  plotOptions: {
    pie: {
      allowPointSelect: false,
      cursor: 'default',
      dataLabels: {
        enabled: false,
      },
      showInLegend: true,
      innerSize: '60%',
    },
  },
  series: [],
  colors: [],
  legend: false,
};



// WEBPACK FOOTER //
// ./src/constants/topologymap-major-info.js